import React from "react";
import { supabase } from "../../../lib/supabaseClient";
import googleSvg from "../../../assets/google.svg";

interface LoginRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LoginRequiredModal: React.FC<LoginRequiredModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleLogin = async () => {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: "google",
        options: {
          redirectTo: `${window.location.origin}${window.location.pathname}`,
          queryParams: {
            access_type: "offline",
            prompt: "consent",
          },
        },
      });

      if (error) {
        // console.error("Sign in error:", error);
        alert("Failed to sign in. Please try again.");
      } else {
        onClose();
      }
    } catch (err) {
      // console.error("Sign in error:", err);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4" onClick={onClose}>
      <div
        className="bg-gray-900 border-2 border-red-600 rounded-xl max-w-md w-full p-6 shadow-[0_0_40px_rgba(220,38,38,0.5)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-bold text-white">Login Required</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="space-y-4">
          <p className="text-gray-300 text-lg">You need to be logged in to use this feature. Sign in with your Google account to:</p>
          <ul className="text-gray-400 space-y-2 list-disc list-inside">
            <li>Mark films as watched, favorites, or add to watchlist</li>
            <li>Set films as currently watching</li>
            <li>Create and join watch parties</li>
            <li>Track your film interactions</li>
          </ul>

          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center space-x-2 bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
          >
            <img src={googleSvg} alt="Google" className="w-5 h-5" />
            <span>Sign in with Google</span>
          </button>

          <button onClick={onClose} className="w-full text-gray-400 hover:text-white transition-colors text-sm">
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginRequiredModal;
